export { default as MessagesList } from './MessagesListContainer'
export {
  notifyError,
  notifyCompleteCheckoutError,
  notifyDuplicatePOCheckoutError,
  logError,
  dismissMessage 
} from './messagesListActionCreators'


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/UserMessaging/index.js